import React from "react";
import { motion } from "framer-motion";

export const Silhouette = ({ size = 220, color = "#00F0FF", older = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.4, ease: "easeOut" }}
      className="silhouette-glow"
      style={{ width: size, height: size * 1.4 }}
      data-testid="silhouette"
    >
      <svg
        viewBox="0 0 100 140"
        width="100%"
        height="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id="bodyGrad" cx="50%" cy="40%" r="70%">
            <stop offset="0%" stopColor={color} stopOpacity="0.95" />
            <stop offset="55%" stopColor="#B026FF" stopOpacity="0.75" />
            <stop offset="100%" stopColor="#05050A" stopOpacity="0.3" />
          </radialGradient>
          <filter id="blur1">
            <feGaussianBlur stdDeviation="0.6" />
          </filter>
        </defs>
        {/* head */}
        <circle cx="50" cy="22" r="12" fill="url(#bodyGrad)" filter="url(#blur1)" />
        {/* body */}
        <path
          d="M30 55 Q50 42 70 55 L68 100 Q50 108 32 100 Z"
          fill="url(#bodyGrad)"
          filter="url(#blur1)"
        />
        {/* legs */}
        <path d="M38 100 L36 136 L46 136 L48 100 Z" fill="url(#bodyGrad)" filter="url(#blur1)" />
        <path d="M52 100 L54 136 L64 136 L62 100 Z" fill="url(#bodyGrad)" filter="url(#blur1)" />
        {older && (
          /* cane */
          <line x1="72" y1="60" x2="80" y2="135" stroke={color} strokeWidth="1.5" opacity="0.6" />
        )}
      </svg>
    </motion.div>
  );
};
